import React from "react";
import type { ComponentType, ReactNode } from "react";
import { lazy, Suspense } from "react";

type LazyImportFunc<P extends object> = () => Promise<{
  default: ComponentType<P>;
}>;

export function withSuspense<P extends object>(
  importFunc: LazyImportFunc<P>,
  fallback: ReactNode = null
) {
  const LazyComponent = lazy(importFunc);

  const WrappedComponent = (props: P) => (
    <Suspense fallback={fallback}>
      <LazyComponent {...props} />
    </Suspense>
  );

  WrappedComponent.displayName = `withSuspense(${LazyComponent.name || "Component"})`;

  return WrappedComponent;
}
